import React from 'react';
import { RefreshCw } from 'lucide-react';

const DataFreshnessChip: React.FC = () => {
  // Mock: 87% of data sources fresh within 2 hours
  const freshnessPct = 87;
  const bars = 5;
  const filledBars = Math.round((freshnessPct / 100) * bars);

  return (
    <div className="flex items-center gap-3 mb-4 px-1">
      <div className="flex items-center gap-1.5">
        <RefreshCw className="w-3.5 h-3.5 text-gray-400" />
        <span className="text-xs text-gray-500 font-medium">Data freshness</span>
      </div>
      <div className="flex items-center gap-0.5">
        {Array.from({ length: bars }).map((_, i) => (
          <div
            key={i}
            className={`w-1.5 h-3 rounded-sm ${
              i < filledBars ? 'bg-niwt-primary' : 'bg-gray-200'
            }`}
          />
        ))}
      </div>
      <span className="text-xs font-semibold text-niwt-primary">{freshnessPct}%</span>
      <span className="text-xs text-gray-400">· updated 12 min ago</span>
    </div>
  );
};

export default DataFreshnessChip;
